import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/macbook.png'
import _imports_1 from '@/assets/images/play-button-triangle.png'


const _withScopeId = n => (_pushScopeId("data-v-37b6e5f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home__text" }
const _hoisted_3 = {
  delay: 400,
  class: "home__text-title"
}
const _hoisted_4 = {
  delay: 550,
  class: "home__text-subtitle"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "home__video-preview",
  src: _imports_0,
  alt: "macbook"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home__video-play-button" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "play-button-triangle"
  })
], -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_VideoModal = _resolveComponent("VideoModal")!
  const _directive_motion_slide_from_left = _resolveDirective("motion-slide-from-left")!
  const _directive_motion_fade = _resolveDirective("motion-fade")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createElementBlock("h1", _hoisted_3, [
        _createTextVNode(" Sell print-on-demand products in 3D ")
      ])), [
        [_directive_motion_slide_from_left]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_4, [
        _createTextVNode(" Sell made-to-order products without inventory or app fees. Pay only for what you sell. Create personalisable products, or let your customers create their own. "),
        _hoisted_5,
        _hoisted_6,
        _createTextVNode(" The solution is only a few clicks away. ")
      ])), [
        [_directive_motion_slide_from_left]
      ]),
      _withDirectives(_createVNode(_component_Button, {
        delay: 650,
        primary: "",
        class: "home__text-button",
        link: $setup.CUSTOMIS3D_PROD,
        text: "GET CUSTOMIS3D"
      }, null, 8, ["link"]), [
        [_directive_motion_fade]
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      delay: 400,
      class: "home__video",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.isModalOpen = true), ["stop"]))
    }, _hoisted_9)), [
      [_directive_motion_fade]
    ]),
    ($setup.isModalOpen)
      ? (_openBlock(), _createBlock(_component_VideoModal, {
          key: 0,
          isOpen: $setup.isModalOpen,
          videoLink: $setup.Urls.CUSTOMIS3D_VIDEO,
          onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.isModalOpen = false))
        }, null, 8, ["isOpen", "videoLink"]))
      : _createCommentVNode("", true)
  ]))
}